import { useRef } from "react";
import { useEffect } from "react";

const VARIABLE_NAME = "--banner-height";

export default function Banners({ children }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current === null) {
      return;
    }

    const doc = document.documentElement;

    const resizeObserver = new ResizeObserver(() => {
      const componentHeight = `${ref.current?.clientHeight}px`;
      doc.style.setProperty(VARIABLE_NAME, componentHeight);
    });

    resizeObserver.observe(ref.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return <div ref={ref}>{children}</div>;
}
